(ns journal-app-client.core
  (:require [journal-app-client.views.game :as game]
            [journal-app-client.views.special :as special]
            [reagent.dom.client :as r.dom.client]
            [re-frame.core :as rf]
            [journal-app-client.utils.css :as css]
            [journal-app-client.utils.visibility :as visibility]
            [journal-app-client.events]
            [journal-app-client.subs]
            [journal-app-client.effects]
            [journal-app-client.views :as views]
            [journal-app-client.routes :as routes]
            [journal-app-client.service-worker :as sw]
            [journal-app-client.notification :as notification]))

(defonce root (r.dom.client/create-root (js/document.getElementById "app")))

(defn render [] (r.dom.client/render root [(if goog.DEBUG
                                             (fn [] views/main) ;; Need to add this to force rerender in react 18
                                             views/main)]))

(defn start []
  (rf/clear-subscription-cache!)
  (render))


(defn ^:export init []
  (game/preload-dart-throw-animation)
  (special/preload-3D-objects)
  (rf/dispatch-sync [:initialize-db])
  (routes/add-popstate-listener)
  (css/theme-listener)
  (css/display-mode-listener)
  (start)
  ;; TODO: Reactivate when the app doesn't need frequent updates anymore.
  #_(sw/activate)
  (notification/request-permission)
  (visibility/add-listener))
